export const ELEMENTS_IN_ROW = 3;
